/* eslint-disable no-param-reassign */
import type { Data } from '../../specProcessor';
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as PolarBarLayerSpec } from '../../../../layer/preset/bar/polarBar';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface PolarBarLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type PolarBarLayerType = StandardChartLayerSpec & PolarBarLayerSpec & PolarBarLayerTypeWithFields;

// 创建极坐标柱状图数据类型验证器
const validatePolarBarDataTypes = createDataTypeValidator('polarBar', [
  { field: 'x', type: ['string', 'date'] },
  { field: 'y', type: 'number' }
]);

// 创建极坐标柱状图编码验证器
const validatePolarBarEncoding = createEncodingValidator([{ field: 'x' }, { field: 'y' }]);

// 额外的检查函数 - 检查数据量是否符合建议
const additionalPolarBarChecks = (layer: PolarBarLayerType, data: Data) => {
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];

  // 检查数据量是否小于30
  if (values.length > 30) {
    utils.logger.warn(
      'warning',
      `Data amount for "${layer.type}" layer exceeds recommended limit (30). Current: ${values.length}`
    );
  }

  // 检查x和y轴数据量是否大于1
  const { encoding } = layer;
  const xValues = new Set(values.map(item => item[encoding.x])).size;
  const yValues = new Set(values.map(item => item[encoding.y])).size;

  if (xValues <= 1) {
    utils.logger.warn(
      'warning',
      `The "x" field of the "${layer.type}" layer should have more than 1 unique value`
    );
  }

  if (yValues <= 1) {
    utils.logger.warn(
      'warning',
      `The "y" field of the "${layer.type}" layer should have more than 1 unique value`
    );
  }
};

// 创建并导出极坐标柱状图处理器
export const polarBar = createLayerProcessor<PolarBarLayerType>(
  'polarBar',
  validatePolarBarEncoding,
  validatePolarBarDataTypes,
  additionalPolarBarChecks
);
